import axios from 'axios';
import { GrpUnitGetResponse } from './dto/grpCmmUnitDto';
import { LoginPostRequest, LoginPostResponse } from './dto/loginDto';
import { RsvAccountGetReponse, RsvAccountPutRequest, RsvAccountPutResponse } from './dto/rsvAccountDto';
import { SelectBox, SelectboxGetData } from './dto/selectboxDto';

const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
const LOGIN = '/login';
const RSV_ACCOUNT = '/rsv-account';
const GRP_UNIT = '/grp-unit';
const SELECTBOX = '/selectbox';

export const postlogin = async (req: LoginPostRequest): Promise<LoginPostResponse>  => {
  try {
    const res = await axios.post(`${BASE_URL}${LOGIN}`, req);
    return res.data;
  } catch (error) {
    console.error('Api Error:', error);
    throw error;
  }
};

export const getGuests = async (): Promise<RsvAccountGetReponse> => {
  try {
    const res = await axios.get(`${BASE_URL}${RSV_ACCOUNT}`);
    return res.data;
  } catch (error) {
    console.error('Api Error:', error);
    throw error;
  }
};

export const putData = async (req: RsvAccountPutRequest): Promise<RsvAccountPutResponse>  => {
  try {
    const res = await axios.put(`${BASE_URL}${RSV_ACCOUNT}`, req);
    return res.data;
  } catch (error) {
    console.error('Api Error:', error);
    throw error;
  }
};

export const getPrivacyPolicyUrl = async (): Promise<GrpUnitGetResponse> => {
  try {
    const res = await axios.get(`${BASE_URL}${GRP_UNIT}`);
    return res.data;
  } catch (error) {
    console.error('Api Error:', error);
    throw error;
  }
};

export const getSelectBoxes = async () => {
  try {
    const res = await axios.get(`${BASE_URL}${SELECTBOX}`);

    const countries = getDataByKey(res.data.data, 'COMMON_PARA:COUNTRY');
    const provices = getDataByKey(res.data.data, 'COMMON_PARA:PROVINCE');

    return {countries, provices}
  } catch (error) {
    console.error('Api Error:', error);
    throw error;
  }
};

function getDataByKey(data: SelectboxGetData[], key: string): SelectBox[] | undefined {
  const item = data.find(d => d.key === key);
  return item?.selectBoxes;
}
